import React, { useState } from 'react';

import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import IconButton from '@material-ui/core/IconButton';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';

const ImageResults = (props) => {
	const [ open, setOpen ] = useState(false);
	const [ currentImg, setCurrentImg ] = useState('');

	const handleOpen = (img) => {
		setCurrentImg(img);
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	let imageListContent;

	if (props.images) {
		imageListContent = (
			<GridList cols={3}>
				{props.images.map((img) => (
					<GridListTile key={img.id}>
						<img src={img.largeImageURL} alt="" />
						<GridListTileBar
							title={img.tags}
							subtitle={
								<span>
									by <strong>{img.user}</strong>
								</span>
							}
							actionIcon={
								<IconButton onClick={() => handleOpen(img.largeImageURL)}>
									<ZoomInIcon style={{color:'white'}} />
								</IconButton>
							}
						/>
					</GridListTile>
				))}
			</GridList>
		);
	} else {
		imageListContent = null;
	}

	return (
		<div>
			{imageListContent}
			<Button label="Close" primary={true} onClick={handleClose} />
			<Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
				<img src={currentImg} alt="" style={{ width: '100%' }} />
			</Dialog>
		</div>
	);
};

export default ImageResults;
